import React from 'react'
import Container from '@components/Container'
import { CONTAINER_STYLE, BUTTON_TYPE } from '@helpers/constants'
import SubHeader from '@views/SubHeader'
import Button from '@components/Button'
import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom'
import LibraryBooks from './LibraryBooks'
import LibrarySections from './LibrarySections'
import ContentFilter from '@components/ContentFilter'
import withTooltip from '@components/WithTooltip'

const ButtonWithTooltip = withTooltip(Button)

const Library = () => {
  const { pathname } = useLocation()

  return (
    <>
      <SubHeader>
        <SubHeader.MiddleSection>
          <ButtonWithTooltip
            type={BUTTON_TYPE.SECONDARY_OUTLINE}
            to={`bocker`}
            active={pathname === `/bibliotek/bocker`}
            margin
            tooltip={'Dokletböcker färdiga att dela med klasser/grupper.'}
          >
            Böcker
          </ButtonWithTooltip>
          <ButtonWithTooltip
            type={BUTTON_TYPE.SECONDARY_OUTLINE}
            to={`avsnitt`}
            active={pathname === `/bibliotek/avsnitt`}
            margin
            tooltip={'Avsnitt som du kan spara/lägga till i egna böcker.'}
          >
            Avsnitt
          </ButtonWithTooltip>
        </SubHeader.MiddleSection>

        <SubHeader.RightSection>
          <ContentFilter />
        </SubHeader.RightSection>
      </SubHeader>

      <Container size={CONTAINER_STYLE.DESKTOP}>
        <Routes>
          <Route path={`/avsnitt`} element={<LibrarySections />} />
          <Route path={`/bocker`} element={<LibraryBooks />} />
          <Route path={''} element={<Navigate to="bocker" replace />} />
        </Routes>
      </Container>
    </>
  )
}

export default Library
